<template>
    <div class="px-8">
        <div v-if="saving" class="animate-pulse rounded-md bg-blue-50 p-4 mb-4">
            <div class="flex items-center justify-center">
                <p class="text-sm text-blue-700">
                    Uploading...
                </p>
            </div>
        </div>
        <ul class="grid grid-cols-1 gap-6 sm:grid-cols-3 mt-8">
            <div></div>
            <li class="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                <div class="w-full flex items-center text-center justify-center p-6 space-x-6">
                    <h3 class="text-gray-900 text-xl font-medium">Marketing Agreement</h3>
                </div>
                <div>
                    <div class="-mt-px flex divide-x divide-gray-200">
                        <div class="w-0 flex-1 flex">
                            <a v-if="user.ginInfo.marketing_agreement_url" :href="`/storage/${user.ginInfo.marketing_agreement_url}?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                <span class="ml-3">View Current</span>
                            </a>
                            <span class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-red-400 font-medium border border-transparent rounded-bl-lg" v-else>No Current File</span>
                        </div>
                        <div v-if="$page.props.auth.user.role === $SUPER_ADMIN_ROLE || $page.props.auth.user.role === $ADMIN_ROLE" class="-ml-px w-0 flex-1 flex">
                            <label class="cursor-pointer w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                                <span class="ml-3">Upload New</span>
                                <input accept=".pdf" @change="onChangeMarketingAgreement" ref="marketingAgreement" class="hidden" type="file" name="marketingAgreement">
                            </label>
                        </div>
                    </div>
                </div>
            </li>
            <div></div>
        </ul>
    </div>
</template>


<script>

export default {
    props: {
        user: Object,
    },
    data() {
        return {
            saving: false,
            success: false,
        }
    },
    methods: {
        onChangeMarketingAgreement() {
            let data = new FormData()
            data.append('file', this.$refs.marketingAgreement.files[0])
            this.upload(data)
        },
        upload(data) {
            this.$inertia.post(this.route('users.marketing-agreement.store', this.user.ginInfo.user_id), data,
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.success = true
                }
            )
        }
    }
}
</script>

